import React, { useState, useEffect } from "react";
import {
  Button,
  Form,
  Input,
  InputNumber,
  Select,
  Checkbox,
  Result,
  Modal,
  Radio,
} from "antd";
import { useTranslation } from "react-i18next";



function ChangeLang() {
      const { t, i18n } = useTranslation();
      const [lang, setLang] = useState();
      useEffect(() => {
        if (lang === undefined) {
          setLang("uz");
        }
        chooseLanguage(lang);
      }, [lang]);
       const chooseLanguage = (lang = "uz") => {
         i18n.changeLanguage(lang);
       };

  return (
    <div>
      <Radio.Group
        className="form__lang"
        onChange={(e) => setLang(e.target.value)}
      >
        <Radio.Button defaultChecked value="uz">
          UZ
        </Radio.Button>
        <Radio.Button value="ru">RU</Radio.Button>
      </Radio.Group>
    </div>
  );
}

export default ChangeLang
